import DOMPurify from 'dompurify';

/** 所有协议展示入口共用白名单；与服务端同步，仅允许排版，不加载外部资源。 */
export function cleanAgreementHtml(html: string): string {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'hr', 'pre', 'code'],
    ALLOWED_ATTR: [],
  });
}
